import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel'

export function handleCarousel(configurations) {
    for (const configuration of configurations) {
        const loop = configuration.loop == 1;
        $('#carousel_' + configuration.elementId).owlCarousel({
            margin:10,
            nav: false,
            dots: false,
            loop: loop,
            center: configuration.center == 1,
            responsiveClass:true,
            autoplay: configuration.autoplay == 1,
            autoplayTimeout: 2000,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    loop: loop
                },
                600:{
                    items:3,
                    nav:false,
                    loop: loop
                },
                1000:{
                    items:5,
                    nav:false,
                    loop: loop
                }
            }
        })
    }
}